import React, { Component } from 'react';
import UprinceNavigation from '../../shared/uprinceNavigation/cuProjectNavigation/component';
import ContractMainLayout from './contractMainLayout';
import { getContractingUnit, getProject } from '../../shared/util';


interface Props {
  currentUser: any
}

interface State {
  isContractUnit: boolean;
  isProject: boolean;
}

export class Contract extends Component<Props, State> {
  render() {
    return (
      <UprinceNavigation
        currentUser={this.props.currentUser}
        selectedNavigationIndex={`/CU/${getContractingUnit()}/project/${getProject()}/contract`}
      >
        <ContractMainLayout/>
      </UprinceNavigation>
    );
  }
}

export default (Contract);
